/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：772
 */

"use strict"

var r = require(/* 180 */"../207/787/180")
Object.defineProperty(exports, "__esModule", {
  value: true
})
exports.ApiSpec = exports.MethodType = undefined
exports.MethodType = function e() {
  r(this, e)
  this.params = e.placeholder
  this.result = e.placeholder
}
exports.ApiSpec = function e(t, n) {
  r(this, e)
  this.namespace = t
  this.methods = n
}
